<template>
	<div class="list-head">
		<ul class="bread-con">
			<li class="x-flow">
				<span class="x-inline">
					{{ whichLang($path) ? 'Join us' : 'Join us' }}	>
					<template v-if="activeScope==1">{{ whichLang($path) ? 'Social Recruitment' : 'Social Recruitment'
						}}</template>
					<template v-if="activeScope==2">{{ whichLang($path) ? 'Campus Recruitment' : 'Campus Recruitment'
						}}</template>
				</span>
			</li>
			<li class="x-flow" v-if="activeName!=2&&activeName!=3">
				<div class="dev-con x-flow">
					<i  class="lf69 x-icon-unchecked" type="1" @click.capture="switchType(1,$event)"></i>
					<span class="x-inline">R&D Positions</span>
				</div>
				<div class="dev-con x-flow">
					<i class="x-icon-unchecked" type="2" @click.capture="switchType(2,$event)"></i>
					<span class="x-inline">Non-R&D Positions</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>

    export default {
        props: {
            activeScope: {
                type: Number
            },
            activeType: {
                type: Number
            },
            activeName: {
                type: Number
            }
        },
        methods: {
            switchType: function (typeId, event) {
                const _this = this;
                var posType = 0;
                if (event.target) {
                    const ele = event.target;
                    if ($(ele).hasClass('x-icon-unchecked')) {
                        $(ele).removeClass('x-icon-unchecked')
                        .addClass('x-icon-checked')
                        .parent().siblings(".dev-con").find('i')
                        .removeClass('x-icon-checked')
                        .addClass('x-icon-unchecked');
                        if (typeId == 1) {
                            posType = 1;
                        }
                        if (typeId == 2) {
                            posType = 2;
                        }
                    } else {
                        $(ele).removeClass('x-icon-checked').addClass('x-icon-unchecked');
                        posType = 0
                    }
                    //console.log(event.target)
                    _this.$emit('do', {type: 'type', val: posType})
                }
                //console.log(event)

            },
            whichLang: function (path) {
                return path == 'zh-cn';
            }
        }
    }

</script>

<style scoped>
	.list-head > .bread-con {
		width: 77.5rem;
		height: 5.5rem;
		border: none;
		border-bottom: 1px solid #BBBBBB;
	}

	.bread-con > li {
		width: 38.75rem;
		height: 100%;
		border: none;
	}

	.bread-con > li:nth-child(1) span {
		width: inherit;
		line-height: 5.5rem;
		text-align: left;
		font-size: 1.375rem;
		color: #323232;
	}

	.bread-con > li:nth-child(2) span {
		width: calc(100% - 5.625rem);
		font-size: 1.375rem;
		color: #2A2E2E;
		line-height: 5.5rem;
	}

	.dev-con {
		width: 50%;
		text-align: right;
		cursor: pointer;
	}

	.x-icon-checked {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_select_sel.png");
		width: 1.375rem;
		height: 1.375rem;
		position: relative;
		top: .25rem;
		left: 1.25rem;
	}

	.x-icon-unchecked {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_select_nor.png");
		width: 1.375rem;
		height: 1.375rem;
		position: relative;
		top: .25rem;
		left: 1.25rem;
	}

	.lf69{
		left: 4.3125rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/join/join-bread.vue